import { Observable } from 'rxjs';

export abstract class PromotionRepository {
    abstract getPromotions(): Observable<any>;
}
